function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { ComponentBootstrap } from '@demant/react-bootstrap';
import flexSpotSchema from '@demant/react-bootstrap/lib/schemas/flex-spot-json';
import OticonMoreCampaignComponent from './js/oticon-more-lp';
var moreCampaignData = [];
var FlexSpotMoreComponent = function FlexSpotMoreComponent(_ref) {
  var settings = _ref.settings,
    component = _ref.component;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    campaignData = _useState2[0],
    setCampaignData = _useState2[1];
  useEffect(function () {
    settings.anchor = component.previousElementSibling && component.previousElementSibling.classList.contains('anchor') ? component.previousElementSibling.id : '';
    moreCampaignData.push(settings);
    var elementsLength = document.querySelectorAll('.flex-spot.general-oticon-more') ? document.querySelectorAll('.flex-spot.general-oticon-more').length : null;
    window.outerWidth > 800 ? window.scrollTo(0, 0) : null;
    if (moreCampaignData.length === elementsLength) {
      component.style.display = 'block';
      component.classList.add('rendered');
      setCampaignData(moreCampaignData);
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, campaignData && /*#__PURE__*/React.createElement(OticonMoreCampaignComponent, {
    data: campaignData
  }));
};
var c = new ComponentBootstrap('.flex-spot.general-oticon-more:not(.custom)');
c.schemaData = flexSpotSchema;
c.reactApp = FlexSpotMoreComponent;
c.run();